import { render, staticRenderFns } from "./InspectionShipmentDetailEdit1.vue?vue&type=template&id=5ef3dd88"
import script from "./InspectionShipmentDetailEdit1.vue?vue&type=script&lang=js"
export * from "./InspectionShipmentDetailEdit1.vue?vue&type=script&lang=js"
import style0 from "./InspectionShipmentDetailEdit1.vue?vue&type=style&index=0&id=5ef3dd88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports